export const DEFAULT_RETRIES = 3;
export const DEFAULT_INTERVAL = 500;
